'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var mh = require('multihashing-async');

var crypto = require('libp2p-crypto');

var _require2 = require('libp2p-interfaces/src/crypto/errors'),
    InvalidCryptoExchangeError = _require2.InvalidCryptoExchangeError;

exports.exchanges = ['P-256', 'P-384', 'P-521'];
exports.ciphers = ['AES-256', 'AES-128'];
exports.hashes = ['SHA256', 'SHA512']; // Determines which algorithm to use.  Note:  f(a, b) = f(b, a)

exports.theBest = function (order, p1, p2) {
  var first;
  var second;

  if (order < 0) {
    first = p2;
    second = p1;
  } else if (order > 0) {
    first = p1;
    second = p2;
  } else {
    return p1[0];
  }

  var _iterator = _createForOfIteratorHelper(first),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var firstCandidate = _step.value;

      var _iterator2 = _createForOfIteratorHelper(second),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var secondCandidate = _step2.value;

          if (firstCandidate === secondCandidate) {
            return firstCandidate;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  throw new InvalidCryptoExchangeError('No algorithms in common!');
};

exports.makeMacAndCipher = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(target) {
    var _yield$Promise$all, _yield$Promise$all2;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all([makeMac(target.hashT, target.keys.macKey), makeCipher(target.cipherT, target.keys.iv, target.keys.cipherKey)]);

          case 2:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            target.mac = _yield$Promise$all2[0];
            target.cipher = _yield$Promise$all2[1];

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

function makeMac(hash, key) {
  return crypto.hmac.create(hash, key);
}

function makeCipher(cipherType, iv, key) {
  if (cipherType === 'AES-128' || cipherType === 'AES-256') {
    return crypto.aes.create(key, iv);
  } // TODO: figure out if Blowfish is needed and if so find a library for it.


  throw new InvalidCryptoExchangeError("unrecognized cipher type: ".concat(cipherType));
}

exports.selectBest = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(local, remote) {
    var oh1, oh2, order;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return exports.digest(Buffer.concat([remote.pubKeyBytes, local.nonce]));

          case 2:
            oh1 = _context2.sent;
            _context2.next = 5;
            return exports.digest(Buffer.concat([local.pubKeyBytes, remote.nonce]));

          case 5:
            oh2 = _context2.sent;
            order = Buffer.compare(oh1, oh2);

            if (!(order === 0)) {
              _context2.next = 9;
              break;
            }

            throw new InvalidCryptoExchangeError('you are trying to talk to yourself');

          case 9:
            return _context2.abrupt("return", {
              curveT: exports.theBest(order, local.exchanges, remote.exchanges),
              cipherT: exports.theBest(order, local.ciphers, remote.ciphers),
              hashT: exports.theBest(order, local.hashes, remote.hashes),
              order: order
            });

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.digest = function (buf) {
  return mh.digest(buf, 'sha2-256', buf.length);
};